// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2j_BP","row":"Node_row__1E6fc","label":"Node_label__bg6SY","footer":"Node_footer__1_kGy"};